import { Link } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';

import { AuthCard } from './AuthCard';
import { useSubmit } from './useSubmit';
import { auth } from '../../api/endpoints';
import { Button } from '../../components/Button';
import { ErrorBanner } from '../../components/ErrorBanner';
import { Field } from '../../components/Field';
import { useT } from '../../i18n/provider';

export function ForgotPasswordScreen() {
  const t = useT();
  const { busy, error, fields, submit } = useSubmit<void>();
  const [sent, setSent] = useState(false);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const email = String(new FormData(event.currentTarget).get('email') ?? '');

    void submit(() => auth.forgotPassword(email), () => setSent(true));
  };

  // Same answer whether or not the address exists — `14 §5.1` again.
  if (sent) {
    return (
      <AuthCard title={t('auth.reset.sentTitle')} subtitle={t('auth.reset.sentSubtitle')}>
        <Link to="/login" className="text-sm font-semibold text-primary">
          {t('auth.backToSignIn')}
        </Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard title={t('auth.reset.title')} subtitle={t('auth.reset.subtitle')}>
      <form onSubmit={onSubmit} className="space-y-4">
        {error ? <ErrorBanner error={error} /> : null}
        <Field label={t('auth.email')} name="email" type="email" autoComplete="email" required error={fields.email} />
        <Button type="submit" busy={busy} size="lg" block>
          {t('auth.reset.send')}
        </Button>
      </form>

      <Link to="/login" className="text-sm text-ink-soft transition-colors hover:text-ink">
        {t('auth.backToSignIn')}
      </Link>
    </AuthCard>
  );
}
